module.exports = __webpack_public_path__ + "img/36.10.pH.0ff1466f.png";